/**
 * Доля остатка от последней покупки, 0..1, для полоски в плашке баланса;
 * `null` — показывать нечего (покупок не было, старый бэк, нет суммы).
 *
 * Здесь `Number` допустим, в отличие от остальной денежной математики: результат
 * — геометрия (сколько точек закрасить), а не сумма, которую видит автор. Сверху
 * режем до 1: после бонуса остаток бывает больше покупки (контракт бэка).
 */
export const creditsShare = (
  balance: string | undefined,
  lastPurchase: string | null | undefined,
): number | null => {
  if (!balance || !lastPurchase) return null
  const total = Number(lastPurchase)
  const left = Number(balance)
  if (!Number.isFinite(total) || !Number.isFinite(left) || total <= 0) return null
  return Math.min(1, Math.max(0, left / total))
}
